import {Advisor} from './advisor.model';

export interface IUser {
  id?: string;
  login?: string;
  consultantId: string;
  providerUserId: string;
  firstName: string;
  lastName: string;
  email: string;
  status: UserStatusEnum;
  langKey: string;
  authProvider: string;
  createdBy: string;
  createdDate: Date;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  authorities: UserAuthorities[];
  password?: string;
  superVisor?: Advisor;
  superVisorId?: string;
  abbreviation?: string;
  cost?: number;
  companyId?: string | null;
  // Anzeigeform der am Benutzer gespeicherten Firma (companyId -> abbreviation).
  firma?: string | null;
}

export class User {
  id?: string;
  login?: string;
  consultantId: string;
  providerUserId: string;
  firstName: string;
  lastName: string;
  email: string;
  status: UserStatusEnum;
  langKey: string;
  authProvider: string;
  createdBy: string;
  createdDate: Date;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  authorities: UserAuthorities[];
  password?: string;
  superVisor?: Advisor;
  superVisorId?: string;
  abbreviation?: string;
  cost?: number;
  companyId?: string | null;
  firma?: string | null;
}

export interface UserStatus {
  status: UserStatusEnum;
}

export interface UserAuthorities {
  name: UserAuthoritiesEnum;
}

export interface UserData {
  user: IUser;
}

export enum UserAuthoritiesEnum {
  OFFICE = 'Office',
  SALE = 'Sale',
  ADMIN = 'Admin',
  USER = 'User',
}

export enum UserStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
